import { api } from "@/lib/api"
import type { AuthResponse } from "@rentbase/shared"

export const authService = {
  async login(email: string, password: string): Promise<AuthResponse> {
    const { data } = await api.post("/api/auth/login", { email, password })
    return data.data
  },
  async register(input: {
    email: string
    password: string
    full_name: string
    country_code?: string
    default_currency?: string
  }): Promise<{ requiresOtp: boolean }> {
    const { data } = await api.post("/api/auth/register", input)
    return data.data
  },
  async verifyOtp(email: string, otp: string): Promise<AuthResponse> {
    const { data } = await api.post("/api/auth/verify-otp", { email, otp })
    return data.data
  },
  async resendOtp(email: string): Promise<void> {
    await api.post("/api/auth/resend-otp", { email })
  },
  async forgotPassword(email: string): Promise<void> {
    await api.post("/api/auth/forgot-password", { email })
  },
  async resetPassword(token: string, password: string): Promise<void> {
    await api.post("/api/auth/reset-password", { token, password })
  },
  async verifyEmail(token: string): Promise<void> {
    await api.post("/api/auth/verify-email", { token })
  },
  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await api.post("/api/auth/change-password", { currentPassword, newPassword })
  },
  async getMe() {
    const { data } = await api.get("/api/auth/me")
    return data.data
  },
}
